if($('#app-worksheet-table').length > 0) {


    var locked_container = $('#wsLockedStatus');

    var campaign_ws_check_lock = function () {
        $.ajax({
            type: 'GET',
            url: '/adv/' + advertiser + '/cam/' + campaign + '/ws/checklock',
            dataType: 'json',
            success: function (data) {
                for(var i in data.all){
                   var access = data.all[i];
                   if(typeof data.blocked[access.worksheet_version_id] !== 'undefined' && typeof data.blocked[access.worksheet_version_id][access.market_id] != 'undefined') {
                       var blocked = data.blocked[access.worksheet_version_id][access.market_id];
                       $(".version_" +access.worksheet_version_id + "_market_" + access.market_id + "").html('');
                       var type = '';
                       if(access.market_type == "msa" || access.market_type == "dma")
                           type = access.market_type.toUpperCase();
                       else if(access.market_type =="")
                           type = "Custom";
                       else
                           type = "National";
                       var html = "<a class='button_locked_change_link' href='#' onclick=' show_loader(event), campaign_ws_check_lock()' " +
                           " title='The Market is currently being editing by "+ blocked.user_name +", please request they release the lock. Click here to Check Again.' >"+
                           "<span style='text-decoration: line-through'>"+ type +" - "+ access.market_name + "</span>";

                       if(ordered_markets_list.indexOf(access.market_slug) !== -1)
                           html += '<i class="fa fa-fw fa-shopping-basket" style="color: #f15925; margin-left: 10px; margin-right: 10px"></i>';

                       html += '<i class="ti-lock button_locked_change" style=" margin-left: 10px; margin-top: 50px"></i>';
                       html += "</a>";

                       $(".version_" + access.worksheet_version_id + "_market_" + access.market_id + "").html(html);
                       console.log(".version_" + access.worksheet_version_id + "_market_" + access.market_id + "");
                   }
                   else {
                       var type = '';
                       if (access.market_type == "msa" || access.market_type == "dma")
                           type = access.market_type.toUpperCase();
                       else if (access.market_type == "")
                           type = "Custom";
                       else
                           type = "National";
                       var html = "<a href='/adv/" + advertiser + "/cam/" + campaign + "/ws/v/" + access.wv_number + "/" + access.market_slug + "' onclick='show_loader(event)'>" + type + " - " + access.market_name;

                       if (ordered_markets_list.indexOf(access.market_slug) !== -1)
                           html += '<i class="fa fa-fw fa-shopping-basket" style="color: #f15925; margin-left: 10px; margin-right: 10px"></i>';
                       html += "</a>";

                       $(".version_" + access.worksheet_version_id + "_market_" + access.market_id + "").html(html);
                       console.log(".version_" + access.worksheet_version_id + "_market_" + access.market_id + "");

                   }
                }

                setTimeout(campaign_ws_check_lock, 60000);
                hide_loader();
            },
            error: function (xhr) {
                debug(xhr.responseText);
                hide_loader();
                setTimeout(campaign_ws_check_lock, 60000);
            }

        });
    };

    $('.open-market-li').on('mouseenter', '.button_locked_change',function(){
        $(this).removeClass('ti-lock');
        $(this).addClass('ti-reload');
    });
    $('.open-market-li').on('mouseleave', '.button_locked_change',function(){
        $(this).removeClass('ti-reload');
        $(this).addClass('ti-lock');
    });


    campaign_ws_check_lock();
}
